<template>
  <el-popover placement="top-start" trigger="click">
    <rtc-switch class="rtc-switch"></rtc-switch>
    <animation-switch></animation-switch>
    <change-fontsize></change-fontsize>
    <el-button class="btn-switch" slot="reference">设置</el-button>
  </el-popover>
</template>
<script>
import RtcSwitch from './rtc-switch.vue';
import AnimationSwitch from './animation-switch.vue';
import ChangeFontsize from './change-fontsize.vue';

export default {
  name: 'Setting',
  components: {
    RtcSwitch,
    AnimationSwitch,
    ChangeFontsize
  },
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.btn-switch {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  font-size: 14px;
  border-radius: 42px;
  padding: 0 28px 0 28px;
  border: none;
  margin-right: 10px;
  /deep/ span {
    display: flex;
    align-items: center;
    height: 44px;
  }
}
</style>
